module.exports = __webpack_public_path__ + "al.no2.b350053b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/al.no2.jpg
// module id = zoFW
// module chunks = 0